<template>
  <div class="finance-receipt-settings">
    <v-row>
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4 mt-2">Income Receipt Settings</h1>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          :to="{ name: 'AddIncomeReceiptSettings' }"
          color="primary"
          class="mx-4 mt-2"
          >Add Income Receipt Settings</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="!isLoading && !settings.length > 0">
        <h2>No Income Receipt Settings Found</h2>
      </v-col>
      <v-col
        v-else
        cols="12"
        md="4"
        v-for="setting in settings"
        :key="setting.id"
      >
        <v-card
          class="py-4 mx-4 my-2 px-4"
          :to="{ name: 'EditIncomeReceiptSettings', params: { receipt_settings_id: setting.id } }">
          <h2 class="text-left font-weight-medium">{{ setting.title }}</h2>
          <p class="text-left mt-1 grey--text">{{ setting.receipt_number }}</p>
          <!-- <p class="text--secondary text-left font-weight-medium mb-0">
              <small>{{ particular.title }}</small>
            </p> -->
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc.js";
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "AllIncomeReceiptSettings",
  data() {
    return {
      settings: [],
    };
  },
  computed: {
      ...mapGetters(['accessToken', 'isLoading']),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(['setLoading']),
    async getAllReceiptSettings() {
      var url = Helper.addUrlParams(endpoints.financeReceiptSettings, [
        "active=true",
      ]);
      this.settings = await api.call(this.essentials, url);
    },
  },
  created() {
    this.getAllReceiptSettings();
  },
};
</script>